import { DirectoryEditRestrictionsRealTimeData } from 'src/generated/signalR/directory-edit-restrictions-real-time-data';

export class DirectoryEditRestrictionsUpdated {
   public static readonly type = '[DirectoryEditRestrictions] Updated';

   constructor(public data: DirectoryEditRestrictionsRealTimeData) {}
}
